import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { Competition } from 'app/models/competition'
import { SharepointService } from 'app/services/sharepoint.service'
import { SharepointData } from 'app/models/sharepoint-data'
@Component({
  selector: 'app-competition-background',
  templateUrl: './competition-background.component.html',
  styleUrls: ['./competition-background.component.scss']
})
export class CompetitionBackgroundComponent implements OnInit {

  @Input() competition: Competition;
  @Input() disabled: boolean;
  @Input() competituonUploaderType: string;
  @Output() fileError = new EventEmitter<number>();
  @ViewChild('file') file: any;
  public title: string;
  public icon: any;
  public msg: string;
  constructor(private sharepointService: SharepointService) {
    this.disabled = false;
  }

  ngOnInit() {
    switch (this.competituonUploaderType) {
      case 'background':
        this.title = 'Competition Background';
        this.msg = 'Upload Competition Background';
        break;
      case 'footer':
        this.title = 'Footer Image';
        this.msg = 'Upload an image shown above the copyright text (e.g. partner logo)';
        break;
      default:
        this.title = 'Stadium';
        this.msg = 'Upload Stadium Background';
    }

      if (this.competituonUploaderType === 'background' && this.competition && this.competition.assetBackground) {
        const sharePointFile: SharepointData = Object.assign({}, this.competition.assetBackground, {
          fileName: 'background',
          mimeType: 'image/*',
        });

        this.sharepointService.downSharepointFile(sharePointFile)
          .subscribe((file) => {
            this.icon = URL.createObjectURL(file.content);
          });
      }

      if (this.competituonUploaderType === 'footer' && this.competition && this.competition.has_footer_image
        && this.competition.assetFooterImage) {
        const sharePointFile: SharepointData = Object.assign({}, this.competition.assetFooterImage, {
          fileName: 'footer',
          mimeType: 'image/*',
        });

        this.sharepointService.downSharepointFile(sharePointFile)
          .subscribe((file) => {
            this.icon = URL.createObjectURL(file.content);
          });
      }
  }

  get fileName(): string {
    switch (this.competituonUploaderType) {
      case 'background':
        return this.competition.backgroundFile;
      case 'footer':
        return this.competition.footerImageFile;
      default:
        return this.competition.stadiumFile;
    }
  }

  onImgChange(event): void {
    this.setFile(event.file);
    this.icon = event.url
  }

  onChange(event): void {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileSize = event.target.files[0].size / 1000; // in bytes
      if (fileSize >= 400) {
        this.fileError.emit(fileSize);
        return;
      }
      this.convertBlobToBase64(file).then(b64 => {
        if (file.type.includes('image')) {
          this.setFile(file);
          this.icon = b64;
        }
      });
    }
  }

  removeFooterImage(event: Event): void {
    event.stopPropagation();
    this.competition.has_footer_image = false;
    this.competition.footerImageFile = null;
    this.competition.footerImageUrl = null;
    this.cancel();
  }

  cancel() {
    this.icon = null;
    if ( this.file ) {
      this.file.nativeElement.value = '';
    }
  }

  convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  })
  // TODO Have to change when backend is ready
  onUpload(): void {
    console.log('upload file');
  }

  private setFile(file: File): void {
    switch (this.competituonUploaderType) {
      case 'background':
        this.competition.backgroundFile = file.name;
        this.competition.backgroundUrl = file;
        break;
      case 'footer':
        this.competition.footerImageFile = file.name;
        this.competition.footerImageUrl = file;
        break;
      default:
        this.competition.stadiumFile = file.name;
        this.competition.stadiumUrl = file;
    }
  }

}
